import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  timezone = localStorage.getItem('timezone')?.replace(/"/g, '');;

  constructor(private datepipe: DatePipe){}

  transform(date: any) {
    if (!date) {
      return 'NA';
    }
    if (date == 'NA') {
      return 'NA';
    }

    // Parse the input datetime string
    let newDate = new Date(date);

    try {
      // Create an Intl.DateTimeFormat object with the specified timezone
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: this.timezone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      });


      // Format the date using the formatter
      const formattedDate = formatter.format(newDate);

      //return formattedDate;
      return this.datepipe.transform(formattedDate, 'YYYY-MM-dd, HH:mm:ss');
    } catch (error) {
      let newDate = new Date(date);
      date = this.datepipe.transform(newDate, 'YYYY-MM-dd, HH:mm:ss');
    }
    return date;
  }

}
